import { Text } from "@itwin/itwinui-react";
import styles from "./MessageOverlay.module.css";

interface NoPreviewOverlayOptions {
  filePath?: string;
  message?: string;
}

export const MessageOverlay = ({ filePath, message }: NoPreviewOverlayOptions) => {
  return <div className={styles.noPreview}>
    <div className={styles.message}>
      <Text variant="subheading">{message}</Text>
      {filePath && <Text variant="small" isMuted>{filePath}</Text>}
    </div>
  </div>;
}